module.exports = __webpack_public_path__ + "static/media/logo.161acba5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 162
// module chunks = 0